export enum OperationMode {
  Sowing = "sowing",
  Harvesting = "harvesting",
}
